
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12.882","height":"9.857"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"mail icon","fill":"#969696"}},[_c('path',{attrs:{"data-name":"Path 3149","d":"M11.893 9.856H.993a1.041 1.041 0 01-.989-1.085V1.146A1.043 1.043 0 01.993.06h10.9a.949.949 0 01.726.351 1.129 1.129 0 01.262.735v7.63a1.041 1.041 0 01-.989 1.085zM.993.624a.5.5 0 00-.47.517v7.63a.5.5 0 00.47.516h10.9a.5.5 0 00.47-.516v-7.63a.535.535 0 00-.124-.348.45.45 0 00-.346-.168z"}}),_c('path',{attrs:{"data-name":"Path 3150","d":"M6.436 6.394a1.542 1.542 0 01-.967-.368l-.019-.017-.873-.855-.02-.019L.277.75a.3.3 0 01-.015-.4.946.946 0 01.726-.351h10.9a.946.946 0 01.726.351.3.3 0 01-.015.4l-4.28 4.386a.23.23 0 01-.021.019l-.826.8a1.567 1.567 0 01-1.036.439zm-.65-.818a.984.984 0 001.357-.052l.832-.808.011-.01L12.007.585a.434.434 0 00-.113-.015H.988a.434.434 0 00-.113.015l4.021 4.121.012.011z"}}),_c('path',{attrs:{"data-name":"Path 3151","d":"M11.893 9.856H.988a.947.947 0 01-.726-.352.3.3 0 01.015-.4l4.28-4.384a.251.251 0 01.351 0l.878.861a.984.984 0 001.357-.052l.832-.808a.25.25 0 01.35.005l4.28 4.383a.3.3 0 01.015.4.947.947 0 01-.726.352zM.874 9.271a.425.425 0 00.114.016h10.9a.425.425 0 00.114-.016L8.137 5.312l-.665.645a1.567 1.567 0 01-1.042.437 1.542 1.542 0 01-.967-.368l-.019-.017-.711-.7L.875 9.271z"}})])])
          )
        }
      }
    